<template>
    <a-flex :vertical="vertical" gap="small" >
        <a-card :bordered="false" class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
            <template #title>
                {{  title }} Subida
            </template>
            <a-statistic
            :value="valueUp"
            :precision="precision"
            :suffix="suffix"
            :value-style="{ color: '#cf1322', textAlign: 'center'  }"
            >
                <template #prefix>
                    <ArrowUpOutlined style="color: #52c41a"  />
                </template>
            </a-statistic>
        </a-card>
        <a-card :bordered="false" class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
            <template #title>
                {{  title }} Bajada
            </template>
            <a-statistic
                :value="valueDown"
                :precision="precision"
                :suffix="suffix"
                :value-style="{ color: '#cf1322', textAlign: 'center' }"
            >
                <template #prefix>
                    <ArrowDownOutlined style="color: #52c41a" />
                </template>
            </a-statistic>
        </a-card>
    </a-flex>
    
</template>
<script>
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue';
export default ({
    components: {
        ArrowUpOutlined, ArrowDownOutlined
    },
    props: {
        title: {
            type: String,
            default: "Velocidad",
        },
        valueUp: {
            type: Number,
            default: 0,
        },
        valueDown: {
            type: Number,
            default: 0,
        },
        suffix: {
            type: String,
            default: "Mb",
        },
        precision: {
            type: Number,
            default: 0
        },
        status: {
            type: String,
            default: "success",
        },
        vertical: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
})
</script>